<template>
    <v-dialog v-model="dialog" max-width="650px" persistent>
      <v-card ref="form">
        <v-system-bar color="error" dark v-if="cupo === 0">
          <v-icon> warning </v-icon>
          <v-spacer></v-spacer>
          No se han asignado cupos para el Cargo seleccionado.
        </v-system-bar>
        <v-app-bar color="white" elevate-on-scroll flat>
          <span>
            {{ descripcion}}
          </span>
  
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="asignarCargoAnterior"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> save </v-icon>
              </v-btn>
            </template>
            <span>Asignar cargo anterior</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                @click="closeDialog"
                color="primary"
                v-bind="attrs"
                v-on="on"
                fab
              >
                <v-icon dark> close </v-icon>
              </v-btn>
            </template>
            <span>Volver</span>
          </v-tooltip>
        </v-app-bar>
  
        <v-card-text>
          <v-card>
            <v-autocomplete
              outlined
              dense
              v-model="idAntiguoCargo"
              :items="dtCargos"                   
              item-text="descripcion"
              item-value="id"
              :label="label"
              required
            >
              <template v-slot:item="{ item }">
                <v-list-item-avatar
                  color="primary"
                  class="text-h5 font-weight-light white--text"
                >
                  {{ item.descripcion.charAt(0) }}
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title v-text="item.descripcion"></v-list-item-title>
                  <v-list-item-subtitle v-text="item.codigo"></v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  export default {
    name: "AsignarCargoDialog",
    props: {
      value: Boolean,          // v-model binding
      descripcion: String,     // Descripción del cargo
      dtCargos: Array,         // Lista de cargos anteriores
      cupo: Number,            // Cupo disponible
      label: String            // Etiqueta del campo     
    },
    data() {
      return {
        dialog: this.value,
        idAntiguoCargo: null
      };
    },
    watch: {
      value(val) {
        this.dialog = val;
      },
      dialog(val) {
        this.$emit('input', val);
      }
    },
    methods: {
      asignarCargoAnterior() {
        this.$emit('asignar-cargo', this.idAntiguoCargo);
      },
      closeDialog() {
        this.dialog = false;
      }
    }
  };
  </script>